import { useContext } from 'react';
import { AppNoticesContext } from '../../contexts/notices/app-notices-context';
import type { AppNoticesContextValue } from '../../types/notices/app-notice.type';

/**
 * Accesses the shared transient notice registry.
 * @returns The registry and selected notice.
 * @throws Error when called outside AppNoticesProvider.
 */
export const useAppNotices = (): AppNoticesContextValue => {
  const context = useContext(AppNoticesContext);
  if (!context) {
    throw new Error('useAppNotices must be used within AppNoticesProvider');
  }
  return context;
};
